import { render, staticRenderFns } from "./inoutStatisticalInvestigation.vue?vue&type=template&id=2dc2819e"
import script from "./inoutStatisticalInvestigation.vue?vue&type=script&lang=js"
export * from "./inoutStatisticalInvestigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2dc2819e')) {
      api.createRecord('2dc2819e', component.options)
    } else {
      api.reload('2dc2819e', component.options)
    }
    module.hot.accept("./inoutStatisticalInvestigation.vue?vue&type=template&id=2dc2819e", function () {
      api.rerender('2dc2819e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/chm/status/inoutStatisticalInvestigation.vue"
export default component.exports